import classNames from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { navLinks } from "@constants/navLinks";
import { scrollToTop } from "@utils/scrollUtils";
import { useWindowDimensions } from "@hooks/useWindowDimensions";
import useScrollPosition from "@hooks/useScrollPosition";

import { ReactComponent as IconHamburger } from "@images/icons/icon-hamburger.svg";
import { ReactComponent as IconClose } from "@images/icons/icon-close.svg";

import NavbarLink from "../NavLink/NavLink";
import MobileMenu from "../MobileMenu/MobileMenu";

import "./Navbar.scss";

const MOBILE_BREAKPOINT = 768; // [px]
const NAVBAR_OFFSET_DESKTOP = 40;
const NAVBAR_OFFSET_MOBILE = 5;

const Navbar = () => {
  const [toggled, setToggled] = useState(false);

  const { offset } = useScrollPosition();
  const { width: viewportWidth } = useWindowDimensions();

  const { t } = useTranslation(["common"]);

  const onToggle = () => setToggled(!toggled);

  const isMobileDevice = viewportWidth <= MOBILE_BREAKPOINT;
  const scrollPointWhenScrolled = isMobileDevice ? NAVBAR_OFFSET_MOBILE : NAVBAR_OFFSET_DESKTOP;
  const isScrolled = offset > scrollPointWhenScrolled;

  const menuBtn = (
    <button onClick={onToggle} className="mobile-menu-icon">
      {toggled ? <IconClose /> : <IconHamburger />}
    </button>
  );

  const classes = classNames("app-navbar", { scrolled: isScrolled });

  return (
    <>
      <nav className={classes}>
        <div className="app-navbar-container">
          <button onClick={scrollToTop}>
            <img src="/images/branding/skey-tix-logo.svg" alt="Skey Tix" className="navbar-logo" />
          </button>

          <div className="nav-links">
            {navLinks.map(({ sectionID, tKey, offsetTopDesktop, offsetTopMobile }, index) => {
              return (
                <NavbarLink
                  key={index}
                  sectionID={sectionID}
                  offsetTopDesktop={offsetTopDesktop}
                  offsetTopMobile={offsetTopMobile}
                >
                  {t(tKey as any)}
                </NavbarLink>
              );
            })}
          </div>

          {menuBtn}
        </div>
      </nav>

      {isMobileDevice && <MobileMenu toggled={toggled} onToggle={onToggle} isScrolled={isScrolled} />}
    </>
  );
};

export default Navbar;
